import { takeLatest, put, select, call, take, delay, race } from 'redux-saga/effects';
import {
    GET_TRANSMISSION_VALIDATOR_REQUEST,
    getTransmissionValidatorSuccess,
    getTransmissionValidatorFailure,
    CLOSE_WEBSOCKET_TRANSMISSION_VALIDATOR,
    GET_TRANSMISSION_HISTORY_LOGS_REQUEST,
    getTransmissionHistroyLogsSuccess,
    getTransmissionHistroyLogsFailure
} from '../actions/transmissionValidator';
import { showGlobalError } from '../../app/actions/app';
import { accessTokenSelector } from '../../auth/selectors/token';
import { initWebSocket, closeWebSocket } from '../services/ws_transmissionValidator';
import { getTransmissionHistoryLogs } from '../services/historyLogs';

let continueWhileWebsocket = true;

const getTransmissionsWorker = function* ({ payload: { filters } }) {

    try {
        const token = yield select(accessTokenSelector);
        yield call(closeWebSocket);

        const channel = yield call(initWebSocket, filters, token);

        continueWhileWebsocket = true;

        while (continueWhileWebsocket) {
            const response = yield take(channel);

            const { data } = response;
          
            if (data) {
                yield put(getTransmissionValidatorSuccess(response));
            } else {
                yield race({
                    reconnectWebSocketWorker: call(reconnectWebSocketWorker, filters),
                    closeWebSocketWorker: take(CLOSE_WEBSOCKET_TRANSMISSION_VALIDATOR)
                });
            }
        }
    } catch (err) {
       
        console.log(err);
        yield put(getTransmissionValidatorFailure(err));
        yield put(showGlobalError(true, err));
    }
};

const getTransmissionHistoryLogsWorker = function* ({ payload: { imei, filters } }) {
    try {
        const token = yield select(accessTokenSelector);
      
        if (!token) {
            console.error('No token available for request');
            yield put(getTransmissionHistroyLogsFailure(new Error('No authentication token available')));
            return;
        }

        const { data: { events, total } } = yield call(getTransmissionHistoryLogs, imei, filters, token);

        yield put(getTransmissionHistroyLogsSuccess(events, total));

    } catch (error) {
        console.log(error);
        yield put(getTransmissionHistroyLogsFailure(error));
        yield put(showGlobalError(true, error));
    }
}

const closeWebSocketWorker = function* () {
    try {
        yield call(closeWebSocket);
        continueWhileWebsocket = false;
    } catch (error) {
        console.error(error);
    }
};

const reconnectWebSocketWorker = function* (filters) {
    yield delay(1000 * 15);
    yield call(getTransmissionsWorker, { payload: { filters } });
};

export default [
    takeLatest(GET_TRANSMISSION_VALIDATOR_REQUEST, getTransmissionsWorker),
    takeLatest(GET_TRANSMISSION_HISTORY_LOGS_REQUEST, getTransmissionHistoryLogsWorker),
    takeLatest(CLOSE_WEBSOCKET_TRANSMISSION_VALIDATOR, closeWebSocketWorker)
];
